export default "__VITE_ASSET__DA3v2gzA__"